import { KontentComponentLayout, KontentComponentSettings } from "../types";
import { getMultiChoice } from "./multichoice";

interface ComponentSettingArgs extends KontentComponentSettings {
  component_layout__component_width?: KontentComponentLayout["component_layout__component_width"];
}

export function getComponentSettings(args: ComponentSettingArgs) {
  return {
    id: args.id,
    anchor: args.component_settings__anchor_name?.value,
    hideOnMobile:
      getMultiChoice(args.component_settings__hide_on_mobile) === "yes",
    width: args.component_layout__component_width
      ? getMultiChoice(args.component_layout__component_width)
      : null,
  };
}
